import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./assets/css/style.css";
import Layout from "./components/Layout";
import JobBoard from "./components/JobBoard/JobBoard";
import EditJob from "./components/EditJob";
import AddJob from "./components/AddJob";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<JobBoard />} />
          <Route path="/edit/:jobId" element={<EditJob />} />
          <Route path="/add" element={<AddJob />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
